<template>
    <template v-if="isExperienceSourceMalt">
        <div class="profile__resume-import__experience__source experience-source-malt" :data-testid="`${dataTestid}--malt`">
            <VJoyLink
                :href="`#${experienceId ? anchorsPageProfile.experienceById(experienceId) : anchorsPageProfile.experiencesSection}`"
                target="_blank"
                class="profile__resume-import__experience__source experience-source-malt__link"
            >
                {{ $t('profile.experience.funnel.step.experience_list.source.malt') }}
                <MaltImg src="/navbar/malt-logo-red.svg" alt="Malt" width="60" densities="1x" />
            </VJoyLink>
        </div>
    </template>
    <VJoyTag variant="secondary" :data-testid="`${dataTestid}--resume`">
        {{ $t('profile.experience.funnel.step.experience_list.source.resume') }}
    </VJoyTag>
</template>
<script lang="ts" setup>
    import {computed} from 'vue';
    import {MaltImg} from '#components';
    import {VJoyLink, VJoyTag} from '@maltjoy/core-vue';
    import {anchorsPageProfile} from '~/config/anchors';
    import {ResumeImportExperienceSource} from '~/features/resume-import/types/ResumeImportExperience';

    const props = defineProps<{
        experienceSource: ResumeImportExperienceSource;
        experienceId?: string;
        dataTestid?: string;
    }>();

    const isExperienceSourceMalt = computed(() => props.experienceSource === ResumeImportExperienceSource.MALT);
</script>
<style lang="scss">
    .profile__resume-import__experience {
        &__source {
            display: flex;
            align-items: center;
            gap: 0.3em;

            &.experience-source-malt {
                &__link {
                    color: var(--joy-color-primary-50) !important;
                    font-weight: var(--joy-font-weight-normal);
                }
            }

            &.experience-source-resume {
                color: var(--joy-color-secondary-50);
            }
        }
    }
</style>
